import React, { useState, useCallback, useRef } from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import Content from './Content'
import { lang } from './lang'
import { TopUpViews } from './types'
import { CardsViews } from '~pages/CardsPage/types'

interface Props {
    isOpen: boolean
    onClose: () => void
    card?: GetCard
    setPageView: (newView: CardsViews) => void
}

function getTitle(view: string) {
    if (view === TopUpViews.general) {
        return <FormattedHTMLMessage {...lang.titleGeneral} />
    }

    if (view === TopUpViews.confirm) {
        return <FormattedHTMLMessage {...lang.titleConfirm} dataPointer="topup_confirmation_title" />
    }

    return undefined
}

function TopUpModal({ isOpen, onClose, card, setPageView }: Props) {
    const [view, setView] = useState(TopUpViews.general)
    const opId = useRef('')

    const onCloseCb = useCallback(() => {
        opId.current = ''
        setTimeout(() => setView(TopUpViews.general), 500)
        onClose()
    }, [onClose])

    return (
        <Modal
            title={getTitle(view)}
            withHeaderBorder={view === TopUpViews.general || view === TopUpViews.confirm}
            onClose={onCloseCb}
            isOpen={isOpen}
            dataPointer="topup_modal"
            size={view === TopUpViews.general ? 's' : 'xs'}
            withModalScroll={view === TopUpViews.general}
            type="dialog"
        >
            <Content
                onClose={onCloseCb}
                setView={setView}
                view={view}
                card={card}
                opId={opId}
                setPageView={setPageView}
            />
        </Modal>
    )
}

export default TopUpModal
